var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 259,
    viewBox: "0 0 375 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-116.467 251.566C16.5693 210.55 61.9677 165.318 78.4205 131.004C96.7809 92.7081 87.3121 50.8522 107.132 48.2529C119.823 46.5879 135.439 62.2173 164.553 96.479C252.841 200.373 254.84 227.963 292.455 235.124C345.149 245.163 377.632 197.936 458.629 198.954C518.118 199.703 566.257 225.999 598.703 249.372",
    stroke: "url(#paint0_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-119.662 247.443C9.62817 207.311 57.6341 163.344 75.3917 131.185C95.2354 95.2455 85.8638 55.5517 105.477 53.6744C118.087 52.4665 133.41 67.8287 161.532 100.916C246.999 201.454 249.65 229.388 286.976 236.195C339.975 245.726 371.042 195.083 452.898 194.393C454.682 194.378 456.439 194.378 458.198 194.408C516.276 195.426 565.1 221.734 598.24 244.964",
    stroke: "url(#paint1_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.846 243.319C2.68881 204.074 53.2647 161.447 72.3727 131.366C93.6699 97.8364 84.4312 60.2548 103.833 59.0969C116.365 58.3474 131.396 73.4435 158.519 105.356C241.146 202.532 244.434 230.9 281.512 237.265C334.769 246.408 364.483 192.203 447.182 189.829C448.996 189.777 450.805 189.724 452.613 189.731C511.65 189.936 563.013 216.787 597.789 240.552",
    stroke: "url(#paint2_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-126.038 239.196C-4.24149 200.826 48.825 159.642 69.3469 131.549C92.0381 100.483 82.9997 64.9626 102.179 64.5217C114.64 64.2344 129.362 79.0582 155.499 109.795C235.297 203.622 239.235 232.362 276.041 238.335C329.581 247.024 357.928 189.302 441.459 185.267C443.313 185.177 445.165 185.091 447.011 185.053C507.004 183.847 560.91 211.839 597.321 236.14",
    stroke: "url(#paint3_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-129.229 235.073C-11.1778 197.591 44.2981 157.934 66.3211 131.732C90.3151 103.184 81.5781 69.6759 100.529 69.9469C112.921 70.1231 127.337 84.6746 152.484 114.236C229.449 204.706 234.039 233.822 270.572 239.405C324.412 247.634 351.382 186.381 435.738 180.7C437.632 180.575 439.528 180.45 441.429 180.372C502.374 178.072 558.822 206.89 596.875 231.73",
    stroke: "url(#paint4_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.418 230.95C-18.1111 194.352 39.6571 156.329 63.3021 131.915C88.4621 105.934 80.1574 74.3918 98.8847 75.3698C111.211 76.0144 125.316 90.2886 149.47 118.676C223.608 205.79 228.853 235.275 265.108 240.475C319.243 248.238 344.844 183.439 430.022 176.14C431.958 175.974 433.893 175.805 435.844 175.698C497.739 172.313 556.741 201.945 596.424 227.323",
    stroke: "url(#paint5_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-135.606 226.826C-25.0474 191.111 34.8644 154.826 60.2743 132.097C86.4159 108.712 78.7477 79.114 97.2311 80.794C109.496 81.9082 123.287 95.9076 146.449 123.115C217.757 206.873 223.662 236.725 259.635 241.544C314.078 248.837 338.298 180.48 424.298 171.577C426.281 171.372 428.252 171.162 430.247 171.021C493.087 166.559 554.641 197.001 595.96 222.912",
    stroke: "url(#paint6_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-138.798 222.704C-31.9847 187.872 24.0048 149.759 57.2494 132.28C77.3846 108.664 77.335 83.844 95.5804 86.2185C107.784 87.8073 121.262 101.519 143.432 127.562C211.908 207.964 218.474 238.177 254.165 242.622C308.913 249.438 331.753 177.511 418.574 167.021C420.593 166.778 422.613 166.528 424.658 166.35C488.448 160.823 552.56 192.059 595.509 218.509",
    stroke: "url(#paint7_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-141.987 218.58C-38.918 184.631 18.5845 147.534 54.2265 132.461C74.6155 110.943 75.9243 88.5784 93.9317 91.6423C106.076 93.7082 119.237 107.131 140.415 131.996C206.051 209.041 213.291 239.612 248.699 243.685C303.755 250.018 325.209 174.511 412.854 162.451C414.913 162.168 416.975 161.878 419.069 161.666C483.809 155.082 550.461 187.105 595.055 214.091",
    stroke: "url(#paint8_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-145.178 214.458C-45.8542 181.392 13.1612 145.313 51.2007 132.645C71.8435 113.222 74.5126 93.3193 92.2821 97.0665C104.364 99.6133 117.212 112.747 137.397 136.435C200.214 210.13 208.11 241.048 243.23 244.754C298.599 250.598 318.657 171.504 407.134 157.887C409.232 157.565 411.338 157.236 413.479 156.987C479.169 149.353 548.369 182.157 594.599 209.68",
    stroke: "url(#paint9_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-148.366 210.334C-52.7866 178.151 7.73991 143.088 48.1768 132.827C69.0735 115.502 73.0989 98.066 90.6304 102.49C102.651 105.523 115.188 118.363 134.381 140.871C194.366 211.206 202.931 242.476 237.762 245.821C293.444 251.168 312.102 168.48 401.413 153.321C403.553 152.957 405.7 152.592 407.887 152.306C474.533 143.629 546.278 177.208 594.143 205.266",
    stroke: "url(#paint10_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-151.559 206.21C-59.7288 174.912 2.32063 140.865 45.153 133.015C66.3034 117.786 71.6813 102.821 88.9768 107.92C100.932 111.442 113.159 123.983 131.359 145.321C188.514 212.299 197.747 243.911 232.293 246.899C288.292 251.744 305.538 165.46 395.69 148.767C397.872 148.363 400.053 147.96 402.296 147.643C469.897 137.927 544.184 172.273 593.685 200.869",
    stroke: "url(#paint11_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-154.749 202.087C-66.6631 171.673 -3.10857 138.643 42.1272 133.193C63.5314 120.062 70.2557 107.574 87.3292 113.339C99.2152 117.354 111.135 129.594 128.343 149.757C182.677 213.379 192.572 245.329 226.822 247.965C283.139 252.298 298.965 162.411 389.97 144.2C392.189 143.755 394.421 143.315 396.712 142.957C465.273 132.215 542.098 167.313 593.235 196.451",
    stroke: "url(#paint12_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.934 197.964C-73.5995 168.433 -8.53195 136.42 39.1032 133.378C60.7593 122.344 68.8261 112.332 85.6794 118.764C97.494 123.273 109.11 135.209 125.327 154.196C176.823 214.463 187.394 246.751 221.353 249.035C277.991 252.85 292.385 159.353 384.247 139.637C386.507 139.151 388.784 138.674 391.116 138.279C460.639 126.508 540 162.371 592.785 192.041",
    stroke: "url(#paint13_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-161.128 193.84C-80.5357 165.192 -13.9531 134.197 36.0794 133.558C57.9894 124.621 67.3927 117.092 84.0299 124.191C95.7671 129.196 107.086 140.825 122.301 158.638C170.968 215.549 182.209 248.163 215.876 250.107C272.833 253.395 285.79 156.303 378.518 135.075C380.819 134.549 383.139 134.036 385.516 133.603C456.009 120.811 537.9 157.427 592.311 187.633",
    stroke: "url(#paint14_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-164.318 189.717C-87.472 161.952 -19.3764 131.973 33.0536 133.741C55.2193 126.901 65.9512 121.855 82.3802 129.611C94.0361 135.115 105.06 146.439 119.293 163.076C165.128 216.629 177.04 249.57 210.417 251.175C267.694 253.929 279.203 153.229 372.805 130.516C375.145 129.949 377.509 129.399 379.944 128.931C451.397 115.114 535.816 152.477 591.863 183.215",
    stroke: "url(#paint15_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-167.509 185.595C-94.4063 158.714 -24.7997 129.756 30.0297 133.924C52.4373 129.177 64.5038 126.621 80.7305 135.037C92.2992 141.038 103.035 152.054 116.275 167.512C159.28 217.709 171.862 250.97 204.948 252.239C262.544 254.45 272.598 150.149 367.085 125.942C369.464 125.333 371.872 124.748 374.344 124.242C446.781 109.424 533.73 147.531 591.407 178.81",
    stroke: "url(#paint16_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-170.698 181.466C-101.342 155.468 -30.222 127.523 27.0048 134.102C49.6762 131.455 63.0514 131.379 79.0779 140.455C90.5593 146.95 101.01 157.663 113.257 171.951C153.432 218.791 166.684 252.37 199.478 253.309C257.395 254.973 265.986 147.072 361.365 121.387C363.782 120.735 366.235 120.115 368.754 119.572C442.171 103.737 531.633 142.586 590.952 174.405",
    stroke: "url(#paint17_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-173.887 177.343C-108.278 152.237 -36.3968 140.987 23.9829 134.288C46.577 131.782 61.5961 136.148 77.4302 145.883C88.8184 152.878 98.9871 163.283 110.243 176.395C147.586 219.881 161.506 253.771 194.011 254.384C252.244 255.482 259.365 143.984 355.644 116.819C358.099 116.127 360.602 115.471 363.164 114.891C437.563 98.0495 529.536 137.636 590.498 169.988",
    stroke: "url(#paint18_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-177.078 173.223C-115.209 148.991 -42.4338 126.598 20.9581 134.47C43.8258 137.31 60.1318 140.911 75.7795 151.307C87.0706 158.802 96.9598 168.896 107.224 180.835C141.739 220.965 156.324 255.161 188.542 255.452C247.087 255.982 252.733 140.891 349.921 112.255C352.417 111.521 354.963 110.834 357.573 110.213C433.013 92.4629 527.449 132.69 590.047 165.579",
    stroke: "url(#paint19_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-180.27 169.101C-122.15 145.752 -47.3682 122.606 17.9333 134.653C41.0965 138.927 58.6637 145.676 74.1289 156.731C85.3189 164.725 94.9343 174.513 104.205 185.275C135.891 222.049 151.142 256.637 183.072 256.523C241.929 256.314 246.024 137.708 344.199 107.693C346.73 106.914 349.324 106.195 351.98 105.536C428.388 86.7367 525.356 127.742 589.585 161.167",
    stroke: "url(#paint20_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-183.46 164.979C-129.087 142.515 -51.915 118.639 14.9074 134.838C115.643 159.262 124.358 258.169 177.605 257.594C238.304 256.939 239.545 128.268 346.39 100.86C423.762 81.0123 523.272 122.796 589.129 156.759",
    stroke: "url(#paint21_linear_3075_5678)",
    strokeWidth: 1.02025,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3075_5678",
    x1: -119.381,
    y1: 72.15,
    x2: -29.8612,
    y2: 398.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3075_5678",
    x1: -122.588,
    y1: 76.4924,
    x2: -41.0594,
    y2: 389.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3075_5678",
    x1: -125.782,
    y1: 80.8226,
    x2: -51.913,
    y2: 380.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3075_5678",
    x1: -128.986,
    y1: 85.1434,
    x2: -62.4081,
    y2: 370.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3075_5678",
    x1: -132.187,
    y1: 90.0413,
    x2: -69.0372,
    y2: 369.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3075_5678",
    x1: -135.388,
    y1: 94.9186,
    x2: -75.5486,
    y2: 367.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3075_5678",
    x1: -138.588,
    y1: 99.7759,
    x2: -81.9459,
    y2: 365.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3075_5678",
    x1: -141.79,
    y1: 104.598,
    x2: -88.219,
    y2: 364.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3075_5678",
    x1: -144.991,
    y1: 109.387,
    x2: -94.3842,
    y2: 362.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3075_5678",
    x1: -148.192,
    y1: 114.135,
    x2: -100.426,
    y2: 360.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3075_5678",
    x1: -151.392,
    y1: 118.827,
    x2: -106.341,
    y2: 359.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3075_5678",
    x1: -154.595,
    y1: 123.454,
    x2: -112.124,
    y2: 357.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3075_5678",
    x1: -157.797,
    y1: 127.977,
    x2: -117.764,
    y2: 355.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3075_5678",
    x1: -160.993,
    y1: 132.374,
    x2: -123.238,
    y2: 354.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3075_5678",
    x1: -164.198,
    y1: 136.585,
    x2: -128.535,
    y2: 352.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3075_5678",
    x1: -167.4,
    y1: 140.518,
    x2: -133.601,
    y2: 351.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3075_5678",
    x1: -170.601,
    y1: 136.448,
    x2: -133.82,
    y2: 356.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3075_5678",
    x1: -173.802,
    y1: 132.141,
    x2: -133.776,
    y2: 362.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3075_5678",
    x1: -177.002,
    y1: 127.82,
    x2: -133.602,
    y2: 367.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3075_5678",
    x1: -180.204,
    y1: 123.526,
    x2: -133.34,
    y2: 372.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3075_5678",
    x1: -183.407,
    y1: 119.184,
    x2: -132.93,
    y2: 377.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3075_5678",
    x1: -186.608,
    y1: 114.838,
    x2: -132.407,
    y2: 382.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#54B5C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720646,
    stopColor: "#1785C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571C6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMobile);
export default __webpack_public_path__ + "static/media/heroMobile.7611ec7292384197314da5652bc71cc1.svg";
export { ForwardRef as ReactComponent };